import { createSelector } from 'reselect'

import { RootState } from '../../types'
import { paramSelector } from '../../../utils/selectors'

type WithInvoiceId = {
  invoiceId: string
}

export const selectState = createSelector(
  (s: RootState) => s.invoices,
  b => b
)

export const areInvoicesLoading = createSelector(selectState, s => s.loading)

export const getInvoices = createSelector(selectState, s => s.data)

export const getInvoicesFilter = createSelector(selectState, s => s.filter)

export const getInvoicesFilters = createSelector(selectState, s => s.filters)

export const isInvoiceDetailsLoading = createSelector(
  selectState,
  paramSelector<WithInvoiceId>(),
  (s, { invoiceId }) => s.loadingEntities[invoiceId] || false
)

export const getInvoicetDetails = createSelector(
  selectState,
  paramSelector<WithInvoiceId>(),
  (s, { invoiceId }) => s.invoiceDetails[invoiceId]
)
